import React, { useRef, useState } from 'react'
import { FibaCheckbox, FibaInput, FibaInputNumber, FibaTextArea, Form, GetCookie, ListScreen, send, SERVER_HOST, useFibaMsgBox, useLoading } from '../components'
import { GridColumn } from '@progress/kendo-react-grid'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@progress/kendo-react-dialogs';
import { Field } from '@progress/kendo-react-form';
import axios from 'axios';
import { TOKEN_NAME } from '../constants/token.const';

const CHUNK_SIZE = 2 * 1024 * 1024; // 5MB

const Advice = () => {
  const { t } = useTranslation()
  const gridRef = useRef(null);
  const [show, setShowstate] = useState({ show: false, data: {} })
  const { showLoading } = useLoading()
  const { error, confirm } = useFibaMsgBox()
  const [file, setFile] = useState(null);

  const refreshData = () => {
    if (gridRef.current) {
      gridRef.current.readData()
    }
  }

  const createFunction = () => {
    setShowstate({ show: true, data: {} })
  }

  const detailFuncion = (data) => {
    setShowstate({ show: true, data })
  }

  const handleChange = (e) => {
    setFile(e.target.files[0]);
  };

  const onClose = () => {
    setFile(null)
    setShowstate({ show: false, data: {} });
  }

  const onSubmit = async (data) => {
    if (!show.data.id) {
      if (!file) {
        return;
      }
      const isconfirm = await confirm(t('confirmsave'));
      if (isconfirm) {
        console.log(CHUNK_SIZE);
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
        const filename = file.name;
        showLoading(true);
        try {
          for (let i = 0; i < totalChunks; i++) {
            const start = i * CHUNK_SIZE;
            const end = Math.min(start + CHUNK_SIZE, file.size);
            const chunk = file.slice(start, end);

            const formData = new FormData();
            formData.append("file", chunk, filename);
            formData.append("is_last", i === totalChunks - 1 ? 1 : 0);

            try {
              const res = await axios.post(SERVER_HOST + "/api/v1/upload/file", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: 'Bearer ' + GetCookie(TOKEN_NAME),
                },
              });
              if (res.data.path) {
                data.video = res.data.path;
                const res1 = await send("co000011", data);
                if (res1.status === 'error') {
                  error(res1.message)
                } else {
                  onClose();
                  refreshData()
                }

              }
              console.log(`Chunk ${i + 1}/${totalChunks} uploaded`);
            } catch (error) {
              console.error(`Error uploading chunk ${i}:`, error);
              error("Файл оруулах үед алдаа гарлаа")
              return;
            }
          }
        } finally {
          showLoading(false)
        }
      }

    } else {
      const isconfirm = await confirm(t('confirmsave'));
      if (isconfirm) {
        const res1 = await send("co000012", data, showLoading);
        if (res1.status === 'error') {
          error(res1.message)
        } else {
          onClose();
          refreshData()
        }
      }
    }
  };


  return (
    <div>
      <ListScreen
        read={'co000010'}
        delete={'co000013'}
        customFunction={createFunction}
        detailFuncion={detailFuncion}
        createable={false}
        customFunctionText={t('create')}
        userSendData={show.data}
        ref={gridRef}
      >
        <GridColumn field='id' title={t('id')} filter='numeric' />
        <GridColumn field='name' title={t('name')} filter='text' />
        <GridColumn field='counter' title={t('counter')} filter='numeric' />
      </ListScreen>
      {show.show &&
        <Dialog
          width={'80vw'}
          height={'auto'}
          title={t('detail')}
          onClose={() => {
            setShowstate({
              show: false, data: {}
            });
            refreshData()
          }}
          className="px-0 pt-0"
        >
          <Form
            initialValues={show.data}
            create={'co000011'}
            update={'co000012'}
            id={show.data.id}
            afterRedirect={false}
            onFinish={onClose}
            onSubmit={onSubmit}
          >

            <div className='grid gap-4 md:grid-cols-2 sm:grid-cols-1'>
              {!show.data.id && <div className='col-span-2'>
                <input type="file" onChange={handleChange} />
              </div>}
              <Field
                name={'name'}
                component={FibaInput}
                label={"Хэрэглэгчийн нэр"}
                required={true}
              />
              <Field
                name={'name2'}
                component={FibaInput}
                label={"Хэрэглэгчийн нэр  /ENG/"}
                required={true}
              />
              <Field
                name={'counter'}
                component={FibaInputNumber}
                label={"Үзсэн тоо"}
                required={true}
              />
              <Field
                name={'listorder'}
                component={FibaInputNumber}
                label={"Эрэмбэлэлт"}
                required={true}
              />
              <div className='col-span-2'>
                <Field
                  name={'ispublish'}
                  component={FibaCheckbox}
                  label={"Харуулах эсэх"}
                  required={true}
                />
              </div>

              <Field
                name={'description'}
                component={FibaTextArea}
                label={"Хэрэглэгчийн сэтгэгдэл"}
                required={true}
              />
              <Field
                name={'description2'}
                component={FibaTextArea}
                label={"Хэрэглэгчийн сэтгэгдэл  /ENG/"}
                required={true}
              />
            </div>
          </Form>
        </Dialog>
      }
    </div>
  )
}

export default Advice